export var TimeSpan;
(function (TimeSpan) {
    function is(value) {
        return (typeof value == "object" &&
            (typeof value.years == "number" || value.years == undefined) &&
            (typeof value.months == "number" || value.months == undefined) &&
            (typeof value.days == "number" || value.days == undefined) &&
            (typeof value.hours == "number" || value.hours == undefined) &&
            (typeof value.minutes == "number" || value.minutes == undefined) &&
            (typeof value.seconds == "number" || value.seconds == undefined) &&
            (typeof value.milliseconds == "number" || value.milliseconds == undefined) &&
            (typeof value.years == "number" ||
                typeof value.months == "number" ||
                typeof value.days == "number" ||
                typeof value.hours == "number" ||
                typeof value.minutes == "number" ||
                typeof value.seconds == "number" ||
                typeof value.milliseconds == "number"));
    }
    TimeSpan.is = is;
    function toHours(value, round) {
        const result = (dateToMilliseconds(value) + (value.milliseconds ?? 0)) / (60 * 60 * 1000) +
            (value.seconds ?? 0) / (60 * 60) +
            (value.minutes ?? 0) / 60 +
            (value.hours ?? 0);
        return performRound(result, round);
    }
    TimeSpan.toHours = toHours;
    function toMinutes(value, round) {
        const result = (dateToMilliseconds(value) + (value.milliseconds ?? 0)) / (60 * 1000) +
            (value.seconds ?? 0) / 60 +
            (value.minutes ?? 0) +
            (value.hours ?? 0) * 60;
        return performRound(result, round);
    }
    TimeSpan.toMinutes = toMinutes;
    function toSeconds(value, round) {
        const result = (dateToMilliseconds(value) + (value.milliseconds ?? 0)) / 1000 +
            (value.seconds ?? 0) +
            (value.minutes ?? 0) * 60 +
            (value.hours ?? 0) * 60 * 60;
        return performRound(result, round);
    }
    TimeSpan.toSeconds = toSeconds;
    function toMilliseconds(value, round) {
        const result = dateToMilliseconds(value) +
            (value.milliseconds ?? 0) +
            (value.seconds ?? 0) * 1000 +
            (value.minutes ?? 0) * 60 * 1000 +
            (value.hours ?? 0) * 60 * 60 * 1000;
        return performRound(result, round);
    }
    TimeSpan.toMilliseconds = toMilliseconds;
})(TimeSpan || (TimeSpan = {}));
function dateToMilliseconds(span) {
    const now = Date.UTC(0, 0);
    const date = new Date(now);
    const future = Date.UTC(date.getUTCFullYear() + (span.years ?? 0), date.getUTCMonth() + (span.months ?? 0), date.getUTCDate() + (span.days ?? 0), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
    return future.valueOf() - date.valueOf();
}
function performRound(value, round) {
    return !round
        ? value
        : round == "ceiling"
            ? Math.ceil(value)
            : round == "floor"
                ? Math.floor(value)
                : Math.round(value);
}
//# sourceMappingURL=TimeSpan.js.map